import { useFormikContext } from "formik";
import { forwardRef } from "react";
import { GetRef } from "tamagui";

import { Input, InputProps } from "./Input";

export interface FormikInputProps
  extends Omit<InputProps, "value" | "error" | "helperText" | "onChangeText"> {
  fieldName: string;
  validateOnBlur?: boolean;
  validateOnChange?: boolean;
}

export const FormikInput = forwardRef<GetRef<typeof Input>, FormikInputProps>(
  function FormikInput(
    { fieldName, validateOnBlur, validateOnChange, onBlur, ...rest },
    ref,
  ) {
    const { values, errors, touched, handleBlur, handleChange, validateField } =
      useFormikContext<Record<string, string | undefined>>();

    const value = values[fieldName];
    const error = errors[fieldName];
    const isTouched = touched[fieldName];

    return (
      <Input
        ref={ref}
        value={value}
        error={isTouched && !!error}
        helperText={isTouched && error ? error : undefined}
        onBlur={(event) => {
          handleBlur(fieldName)(event);
          onBlur?.(event);
          if (validateOnBlur) {
            validateField(fieldName);
          }
        }}
        onChangeText={(event) => {
          handleChange(fieldName)(event);
          if (validateOnChange) {
            validateField(fieldName);
          }
        }}
        {...rest}
      />
    );
  },
);
